import React, { FC } from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
import ModalDialog from './modal/ModalDialog';
import { Button, ButtonSize } from '../common/Button';
import { useTranslation } from 'react-i18next';

const VideoPlayerPopupStyled = styled.div`
    position: relative;
    padding-bottom: 56.25%;
    margin-bottom: 50px;
    height: auto;
    overflow: hidden;
    max-width: 100%;

    iframe,
    object,
    embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`;

// TODO clean up this shit
const styleForModalWrapper = {
    top: '5%',
    width: '70%',
    maxHeight: '90%',
    overflow: 'auto'
};

const StButtonLine = styled.div`
    display: flex;
    justify-content: flex-end;

    > a ~ a {
        margin-left: 20px;
    }
`;

interface Props {
    vimeoId?: number;
    description?: string;
    isTutorialVideoEntryPage?: boolean;
    showVideo: boolean;
    title?: string;
    hideVideo: (neverShowAgain?: any) => void;
}

const VideoPlayerPopup: FC<Props> = ({
    vimeoId,
    description = null,
    isTutorialVideoEntryPage = false,
    hideVideo,
    showVideo,
    title = ''
}) => {
    const wrapperClassesForStyle = !isTutorialVideoEntryPage ? null : 'welcome';
    const { t } = useTranslation();
    return (
        <ModalDialog
            onCloseButtonClick={hideVideo}
            show={showVideo}
            title={title}
            wrapClassStyleForVideo={styleForModalWrapper}
            wrapClassName={wrapperClassesForStyle}
        >
            {!description ? null : <p>{description}</p>}
            <VideoPlayerPopupStyled>
                <ReactPlayer
                    url={`https://player.vimeo.com/video/${vimeoId}`}
                    width="100%"
                    height="100%"
                    controls={true}
                />
            </VideoPlayerPopupStyled>
            <StButtonLine>
                {isTutorialVideoEntryPage ? (
                    <Button text={t('components.footer.done')} onClick={hideVideo} size={ButtonSize.LARGE} />
                ) : null}
                {isTutorialVideoEntryPage ? (
                    <Button
                        text={t('components.footer.showAgainLater')}
                        onClick={() => hideVideo(false)}
                        size={ButtonSize.LARGE}
                    />
                ) : null}
            </StButtonLine>
        </ModalDialog>
    );
};

export default VideoPlayerPopup;
